export default __webpack_public_path__ + "static/media/mw.8e62aef0.svg";